<template>
    <div id="fh5co-page">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue